<template>
<div class="admin-cont">
    <v-container>
        <v-btn color="red" @click.native="signOut" style="margin: 20px 0;">
            Sign Out
            <v-icon right aria-hidden="true">
                mdi-logout
            </v-icon>
        </v-btn>
        <div v-if="files.length > 0">
            <v-data-table light :headers="headers" :search="search" :items="files" :items-per-page="10" class="elevation-1" >
                <template v-slot:item.uploadDate="{ item }">
                    <div id="upload-date-container"><span id="upload-date">{{ getDateStamp(item.uploadDate) }}</span> <br> {{ getTimeStamp(item.uploadDate) }}</div>
                </template>
                <template v-slot:item.approved="{ item }">
                    <div class="approve-icon-cont">
                        <v-icon color="green" v-if="item.approved">mdi-check</v-icon>
                        <v-icon color="red" v-else>mdi-close</v-icon>
                    </div>
                </template>
                <template v-slot:item.goldPick="{ item }">
                    <div class="approve-icon-cont">
                        <v-icon color="green" v-if="item.goldPick">mdi-check</v-icon>
                        <v-icon color="red" v-else>mdi-close</v-icon>
                    </div>
                </template>
                <template v-slot:item.likes="{ item }">
                    <div id="likes-container">
                        <v-icon x-small>mdi-cards-heart</v-icon>
                        {{ item.likes }}
                    </div>
                </template>
                <template v-slot:top>
                    <v-toolbar flat>
                        <v-toolbar-title>Submissions</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                        <v-spacer></v-spacer>
                        <v-dialog v-model="dialog" max-width="500px">
                            <v-card class="mx-auto">
                                <v-card-title>
                                    <span class="headline">{{ formTitle }}</span>
                                </v-card-title>
                                <v-card-text>
                                    <v-text-field v-model="editedItem.songName" label="Name"></v-text-field>
                                    <v-text-field v-model="editedItem.path" label="Audio Source"></v-text-field>
                                    <v-img class="ma-3" :src="editedItem.coverURL" contain width=215 />
                                    <audio controls :src="editedItem.path">
                                        Your browser does not support the audio element.
                                    </audio>
                                </v-card-text>
                                <v-card-text><b>Notes:</b> {{ editedItem.notes ? editedItem.notes : 'No track credits.'}}</v-card-text>
                                <v-card-actions>
                                    <v-spacer></v-spacer>

                                    <div v-if="editedItem.approved">
                                        <v-btn color="deep-purple accent-4" text @click="unapprove">Unapprove</v-btn>
                                    </div>
                                    <div v-else>
                                        <v-btn color="deep-purple accent-4" text @click="approve">Approve</v-btn>
                                    </div>
                                    <div v-if="editedItem.goldPick">
                                        <v-btn color="deep-purple accent-4" text @click="unGoldPick">Un Gold Pick</v-btn>
                                    </div>
                                    <div v-else>
                                        <v-btn color="deep-purple accent-4" text @click="goldPick">Gold Pick</v-btn>
                                    </div>
                                    <v-btn color="red accent-4" text @click="dialog = false">Close</v-btn>
                                </v-card-actions>
                            </v-card>
                        </v-dialog>
                    </v-toolbar>
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" @click="editItem(item)">
                        mdi-pencil
                    </v-icon>
                    <v-icon small @click="deleteItem(item)">
                        mdi-delete
                    </v-icon>
                </template>
                <template v-slot:no-data>
                    <v-btn color="primary" @click="retrieveImages">Reset</v-btn>
                </template>
            </v-data-table>
        </div>
        <div v-else>
            <p>No files</p>
        </div>
        <v-btn class="sample-btn" @click="onPressSamples">View Collab Collection</v-btn>
    </v-container>
</div>
</template>

<script>
import { auth, db } from '@/config/firebaseInit'
import { environment } from '@/constants';
import moment from 'moment';
export default {
    name: "FBListSubmissions",
    data: function () {
        return {
            search: '',
            files: [],
            dialog: false,
            headers: [
                {
                    text: 'Upload Date',
                    align: 'start',
                    sortable: true,
                    value: 'uploadDate'
                },
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'name'
                },
                {
                    text: 'Age',
                    sortable: true,
                    value: 'age'
                },
                {
                    text: 'Song Name',
                    align: 'start',
                    sortable: true,
                    value: 'songName'
                },
                {
                    text: 'Email',
                    value: 'email'
                },
                {
                    text:'Likes',
                    value:'likes'
                },
                {
                    text: 'Approved',
                    value: 'approved',
                    sortable: true
                },
                {
                    text: 'Gold Pick',
                    value: 'goldPick'
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false
                },

            ],
            editedIndex: -1,
            editedItem: {
                name: '',
                path: ''
            },
            defaultItem: {
                name: '',
                path: ''
            },
        }
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? 'New Item' : 'Review Submission'
        },
    },

    watch: {
        dialog(val) {
            val || this.close()
        },
    },
    created() {
        this.retrieveImages()
    },
    methods: {
        signOut() {
            auth.signOut().then(() => {
                // Sign-out successful.'
                this.$router.push({
                    path: '/'
                });
            }).catch(function (error) {
                // An error happened.
                console.log("error: ", error)
            });
        },
        retrieveImages() {
            let filesArray = [];
            db.collection(`${environment}-submissions`)
              .orderBy('uploadDate', 'desc')
              .get().then(function (querySnapshot) {
                querySnapshot.forEach(function (doc) {
                    // doc.data() is never undefined for query doc snapshots
                    const {
                        name,
                        // same as name, but can't edit FB fields
                        artistName,
                        age,
                        email,
                        fileURL,
                        coverURL,
                        songName,
                        // same as songName, but can't edit FB fields
                        songname,
                        likes,
                        approved,
                        goldPick,
                        uploadDate
                    } = doc.data();
                    filesArray.push({
                        id: doc.id,
                        uploadDate,
                        email,
                        likes,
                        name: name || artistName,
                        age: age || 'N/A',
                        coverURL: `${coverURL}`,
                        songName: songName || songname,
                        artistName: artistName,
                        path: `${fileURL}`,
                        approved: approved || false,
                        goldPick: goldPick || false
                    });
                });
            });
            this.files = filesArray;
        },
        getDateStamp(date) {
          return moment(date).format('L');
        },
        getTimeStamp(time) {
            return moment(time).format('LT');
        },
        editItem(item) {
            this.editedIndex = this.files.indexOf(item)
            this.editedItem = Object.assign({}, item)
            this.dialog = true
        },

        deleteItem(item) {
            const index = this.files.indexOf(item);
            confirm('Are you sure you want to delete this song?') && this.removeSong(index);
        },

        removeSong(index) {
            const deletedSong = this.files[index];
            const deletedSongRef = db.collection(`${environment}-submissions`).doc(deletedSong.id);

            deletedSongRef.delete().then(() => {
                this.files.splice(index, 1);
            }).catch((err) => {
                console.log('Could not delete song: ', err);
            });
        },

        close() {
            this.dialog = false
            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem)
                this.editedIndex = -1
            }, 300)
        },

        save() {
            if (this.editedIndex > -1) {
                Object.assign(this.files[this.editedIndex], this.editedItem)
            } else {
                this.files.push(this.editedItem)
            }
            this.close()
        },
        approve() {
            const {
                id
            } = this.editedItem;
            const docRef = db.collection(`${environment}-submissions`).doc(id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    docRef.set({
                        approved: true
                    }, {
                        merge: true
                    })
                    this.dialog = false
                    this.retrieveImages()
                    alert("Submission Approved")

                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        unapprove() {
            const {
                id
            } = this.editedItem;
            const docRef = db.collection(`${environment}-submissions`).doc(id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    docRef.set({
                        approved: false,
                        goldPick: false,
                    }, {
                        merge: true
                    })
                    this.dialog = false
                    this.retrieveImages()
                    alert("Submission Unapproved")

                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        goldPick() {
            const {
                id
            } = this.editedItem;
            const docRef = db.collection(`${environment}-submissions`).doc(id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    docRef.set({
                        goldPick: true,
                        approved: true
                    }, {
                        merge: true
                    })
                    // this.dialog = false
                    this.retrieveImages()
                    alert("Gold Pick Approved")
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        unGoldPick() {
            const {
                id
            } = this.editedItem;
            const docRef = db.collection(`${environment}-submissions`).doc(id);

            docRef.get().then((doc) => {
                if (doc.exists) {
                    docRef.set({
                        goldPick: false,
                    }, {
                        merge: true
                    })
                    this.dialog = false
                    this.retrieveImages()
                    alert("Gold Pick Unapproved")
                } else {
                    // doc.data() will be undefined in this case
                    console.log("No such document!");
                }
            }).catch(function (error) {
                console.log("Error getting document:", error);
            });
        },
        onPressSamples() {
            this.$router.push({ path: '/samples' });
        }
    }

}
</script>

<style lang="scss" scoped>
    .admin-cont {
        background-color: white;
        padding-bottom: 300px;
        height: 100%;
    }

    #likes-container {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
    }

    #upload-date-container {
        text-align: center;
    }

    #upload-date {
        font-weight: bold;
        padding: 5px;
        border-radius: 4px;
        margin: 0;
    }

    .approve-icon-cont {
        display: flex;
        justify-content: center;
    }

    .sample-btn {
        margin: 20px 0;
    }
</style>
